// extracted by mini-css-extract-plugin
export default {"info-list-item-container":"xtccJgCGc9TO4cSeIBlh","info-list-item":"P2qcTlXdP8JMBJTO8R0A"};